<template>
	<div class="form-model-main">
		<div class="add-page-content">
			<div class="title">{{modelTitle}}</div>
			<div class="content">
				<a-form>
					<a-row class="input-row">
						<a-col class="left input-row-title" :span="12">
							账户信息
						</a-col>
					</a-row>
					<a-row class="input-row">
						<a-col class="left" :span="12">
							<a-form-item :validate-status="isSubmit&&!isUserName()?'error':''"
							             :help="isSubmit&&!isUserName()?usernameMsg:''">
								<div class="name hospital-required">用户名</div>
								<div>
									<a-input v-model="formData.username" :disabled="usernameDisabled"
									         placeholder="请输入5-32位小写英文字母和数字的组合"/>
								</div>
							</a-form-item>
						</a-col>
						<a-col class="right" :span="12">
							<a-form-item :validate-status="isSubmit&&!formData.nickName?'error':''"
							             :help="isSubmit&&!formData.nickName?'输入真实姓名':''">
								<div class="name hospital-required">真实姓名</div>
								<div>
									<a-input v-model="formData.nickName" placeholder="请输入用户的真实姓名"/>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row">
						<a-col class="left" :span="12">
							<a-form-item :validate-status="isSubmit&&!isTel()?'error':''"
							             :help="isSubmit&&!isTel()?'请输入正确手机号':''">
								<div class="name">手机号</div>
								<div>
									<a-input v-model="formData.mobile" placeholder="请输入手机号"/>
								</div>
							</a-form-item>
						</a-col>
						<a-col class="right" :span="12">
							<a-form-item :validate-status="isSubmit&&!isEmail()?'error':''"
							             :help="isSubmit&&!isEmail()?'请输入正确邮箱':''">
								<div class="name">邮箱</div>
								<div>
									<a-input type="email" v-model="formData.email" placeholder="请输入邮箱"/>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row">
						<a-col class="left input-row-title" :span="12">
							基本信息
						</a-col>
					</a-row>
					<a-row class="input-row">
						<a-col class="left" :span="12">
							<a-form-item>
								<div class="name">组织</div>
								<div>
									<a-tree-select
											:getPopupContainer="triggerNode => triggerNode.parentNode"
											style="width: 300px"
											v-model="formData.deptId"
											@change="onChange"
											treeDefaultExpandAll
											searchPlaceholder='请选择用户所属组织，单选'>
										<a-tree-select-node v-for="(item,index) in treeExpandedKeys" :selectable="false"
										                    :value="item.deptId.toString()"
										                    :title="item.deptName"
										                    :key="item.deptId.toString()">
											<a-tree-select-node v-for="(cItem,i) in item.children"
											                    :value="cItem.deptId.toString()"
											                    :title="cItem.deptName"
											                    :key="cItem.deptId.toString()"/>
										</a-tree-select-node>
									</a-tree-select>
								</div>
							</a-form-item>
						</a-col>
						<a-col class="right" :span="12">
							<a-form-item :validate-status="isSubmit&&!isRole()?'error':''"
							             :help="isSubmit&&!isRole()?'请选择用户所属角色，可多选':''">
								<div class="name hospital-required">所属角色</div>
								<div>
									<!--v-model="formData.roleId"-->
									<a-select
											:getPopupContainer="triggerNode => triggerNode.parentNode"
											mode="multiple"
											v-model="formData.roleId"
											@change="handleRoleChange"
											placeholder="请选择用户所属角色，可多选">
										<a-select-option
												:key="item.roleId"
												v-for="item in roleLst"
												:value="item.roleId">
											{{item.roleName}}
										</a-select-option>
									</a-select>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row" v-if="!isEdit">
						<a-col class="left input-row-title" :span="12">
							安全验证
						</a-col>
					</a-row>
					<a-row class="input-row" v-if="!isEdit">
						<a-col>
							<a-form-item :validate-status="isSubmit&&!formData.password?'error':''"
							             :help="isSubmit&&!formData.password?'请输入系统登录密码':''">
								<div class="name hospital-required">您的系统登录密码</div>
								<div>
									<a-input type="password" v-model="formData.password" placeholder="请输入系统登录密码"/>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
				</a-form>
				<div class="confrim-footer">
					<a-button type="primary" class="cf-mr10" :loading="isHttpSubmit" @click="submitUserInfo()">确定
					</a-button>
					<a-button v-if="!isEdit" type="primary" class="cf-mr10" :loading="isHttpSubmit"
					          @click="submitUserInfo('next')">保存并继续添加
					</a-button>
					<a-button @click="cancelSubmit">取消</a-button>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
  import {regAll} from "../../common/validate";

  export default {
    props: {
      userInfo: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        isSubmit: false,
        isHttpSubmit: false,
        isEdit: false,
        usernameDisabled: false,
        data: [],
        formData: {
          username: '',
          nickName: '',
          deptId: '',
          email: '',
          mobile: '',
          roleId: undefined,
          password: '',
        },
        roleLst: [],
        modelTitle: '新增用户',
        treeExpandedKeys: [],
        usernameMsg: '',
      }
    },
    components: {},
    mounted() {
      if (JSON.stringify(this.userInfo) != '{}') {
        this.isEdit = true;
        this.modelTitle = '编辑用户';
        this.formData = this.userInfo;
        this.usernameDisabled = true;
        if (this.formData.roleId) {
          this.formData.roleId = this.formData.roleId.split(',');
        } else {
          this.formData.roleId = undefined;
        }
        if (this.formData.deptId) {
          this.formData.deptId = this.formData.deptId.toString();
        } else {
          this.formData.deptId = '';
        }
      } else {
        this.modelTitle = '新增用户';
        this.usernameDisabled = false;
        let queryDeptId = this.$route.query.deptId
          ? this.$route.query.deptId.split("-")
          : [];
        if (queryDeptId.length > 0) {
          this.formData.deptId = queryDeptId[queryDeptId.length - 1];
        }
      }
      this.findDeptTreeList();
      this.findRoleLst();

    },
    methods: {
      isUserName() {
        if (this.formData.username) {
          if (!this.regx.testUser.test(this.formData.username)) {
            this.usernameMsg = '请输入正确用户名！';
            return false;
          } else {
            return true;
          }
        } else {
          this.usernameMsg = '请输入用户名！';
          return false;
        }
      },
      isRole() {
        if (this.formData.roleId && this.formData.roleId.length > 0) {
          return true;
        } else {
          return false;
        }
      },
      isTel() {
        if (this.formData.mobile) {
          if (!regAll.regTel.test(this.formData.mobile)) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      },
      isEmail() {
        if (this.formData.email) {
          if (!regAll.regEmail.test(this.formData.email)) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      },
      findDeptTreeList() {
        this.$get("dept/findDeptTreeList").then(
          res => {
            console.log('res', res);
            if (res.data.data) {
              this.treeExpandedKeys = res.data.data;
            }
          },
          err => {
            console.log('err', err);
          }
        );
      },
      findRoleLst() {
        this.$get("role/listNoAdmin").then(
          res => {
            if (res.data.data) {
              this.roleLst = res.data.data;
              this.roleLst.forEach(function (item, i) {
                item.roleId = item.roleId.toString();
              })
            }
          },
          err => {
            console.log('err', err);
          }
        );
      },
      submitUserInfo(next) {
        this.isSubmit = true;
        this.$nextTick(() => {
          const isPass =
            document.querySelectorAll(".ant-form-explain").length == 0;
          if (isPass) {
            let submitData = {};
            submitData.username = this.formData.username;
            submitData.nickName = this.formData.nickName;
            submitData.deptId = this.formData.deptId;
            submitData.email = this.formData.email;
            submitData.mobile = this.formData.mobile;
            submitData.roleId = this.formData.roleId ? this.formData.roleId.join(',') : '';
            if (this.formData.userId) {
              submitData.userId = this.formData.userId;
              this.isHttpSubmit = true;
              this.$put("user/profile", submitData, {
                "Content-Type": "application/json"
              }).then(
                res => {
                  if (res.data.code == 1) {
                    this.$message.success("保存成功，重新登录后生效！");
                    this.$emit("close");
                  } else {
                    this.$message.error(res.data.message);
                  }
                  this.isHttpSubmit = false;
                },
                error => {
                  this.isHttpSubmit = false;
                  this.$message.error("修补用户信息失败!");
                }
              );
            } else {
              submitData.password = this.formData.password;
              this.isHttpSubmit = true;
              this.$post("user", submitData, {
                "Content-Type": "application/json"
              }).then(
                res => {
                  if (res.data.code == 1) {
                    this.$message.success("新增用户成功！");
                    if (next) {
                      this.clearForm();
                    } else {
                      this.$emit("close");
                    }
                  } else {
                    this.$message.error(res.data.message);
                  }
                  this.isHttpSubmit = false;
                },
                error => {
                  this.isHttpSubmit = false;
                  this.$message.error("新增用户失败!");
                }
              );
            }
          }

        })
      },
      clearForm() {
        this.formData = {
          username: '',
          nickName: '',
          deptId: '',
          email: '',
          mobile: '',
          roleId: undefined,
          password: '',
        };
      },
      cancelSubmit() {
        this.$emit("close");
      },
      onChange(value) {
      },
      handleRoleChange(value) {
        // this.formData.roleId = value;
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>